import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers, images } from "../data/landing";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let showTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(Math.floor(Math.random() * 14) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        showTimer = window.setTimeout(show, GAP);
      }, VISIBLE_FOR);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-24 z-50 flex justify-start md:inset-x-auto md:bottom-6 md:left-6" data-id="element-246" data-mp="116mhywpkww73">
      <AnimatePresence data-id="element-247" data-mp="1awpgtdjdt4dc">
        {visible && !dismissed && <motion.div role="status" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-black/5" data-id="element-248" data-mp="1axhfwyc6tk8d">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-ink object-contain p-1" data-id="element-249" data-mp="28jyb9y1d1nrh" />
            <div className="min-w-0" data-id="element-250" data-mp="23m6642bpg55c">
              <p className="text-sm leading-snug text-ink" data-id="element-251" data-mp="23l3ji6lf0ov8">
                <strong data-id="element-252" data-mp="2apcpouelorfa">{buyer.name}</strong> from <strong data-id="element-253" data-mp="2aobfst9bmaz5">{buyer.country}</strong>
              </p>
              <p className="text-sm leading-snug text-slate-700" data-id="element-254" data-mp="2fmuzen0fzaoc">just purchased HOF Clinical Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-emerald-700" data-id="element-255" data-mp="2knsjx68xcgt0">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-256" data-mp="2pksmh76kf1fd" />
                Verified · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-slate-500 hover:text-ink" aria-label="Dismiss notifications" data-id="element-257" data-mp="1wx6dtkihd6ln">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-258" data-mp="26oj26252lemx" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}